//
//  BrandMark.tsx
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: October 14, 2026
//  Author: Bob Keathley
//
//  Signet mark component. Decorative only: the adjacent 'Signet Console' text is
//  the accessible name. Assets are served from the shared public directory.
//
/**
 * The Signet mark. Decorative: the adjacent "Signet Console" text is the accessible name.
 * `shield` (header, <= 32 px) and `mark` (cards, >= 72 px) are served from the shared public dir.
 * The `mark` variant centres itself above the card's brand line.
 */
export default function BrandMark({ variant, size }: { variant: 'shield' | 'mark'; size: number }) {
  return (
    <img
      src={variant === 'shield' ? '/brand/signet-shield.svg' : '/brand/signet-mark.svg'}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={variant === 'mark' ? { display: 'block', margin: '0 auto 12px' } : { display: 'block', flex: 'none' }}
    />
  )
}
